import { useApiClient } from "../../api-client";

enum CommercialCommunicationsDecision {
  SUBSCRIBE = "subscribe",
  UNSUBSCRIBE = "unsubscribe",
}

export const useUpdateCommercialCommunications = () => {
  const { put } = useApiClient();

  const updateCommercialCommunications = (decisionValue: boolean) => {
    const decision = decisionValue
      ? CommercialCommunicationsDecision.UNSUBSCRIBE
      : CommercialCommunicationsDecision.SUBSCRIBE;

    return put("/v1/employees/commercial-communications", {
      decision,
    });
  };

  return {
    updateCommercialCommunications,
  };
};
